import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a338183"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coupon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "coupon__title" }, "Промокод", -1))
const _hoisted_3 = { class: "coupon__form" }
const _hoisted_4 = {
  key: 0,
  class: "input-error coupon__error"
}
const _hoisted_5 = {
  key: 1,
  class: "coupon__name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoPreloader = _resolveComponent("MoPreloader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.couponCode) = $event)),
        type: "text",
        class: _normalizeClass(["base-input base-input--black", { 'base-input--disabled': _ctx.coupon }])
      }, null, 2), [
        [_vModelText, _ctx.couponCode]
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["coupon__btn base-btn base-btn--default", {
          'base-btn--blocked': _ctx.isLoading,
          'coupon__btn--disabled': !_ctx.coupon && !_ctx.couponCode,
        }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.coupon ? _ctx.resetCoupon() : _ctx.$emit('apply', _ctx.couponCode)))
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_MoPreloader, {
              key: 0,
              "is-multiple": true
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.coupon)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Отменить ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Применить ")
                  ], 64))
            ], 64))
      ], 2)
    ]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.coupon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.coupon.name), 1))
      : _createCommentVNode("", true)
  ]))
}